<!-- Loading bar -->
<fuse-loading-bar autoMode="false"></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="dark bg-black print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center justify-center px-2">
            <!-- Light version -->
            <img
                class="h-full w-full dark:hidden"
                src="images/logo/logo-text.svg"
                alt="Logo image"
            />
            <!-- Dark version -->
            <img
                class="h-full w-full hidden dark:flex"
                src="images/logo/logo-text-on-dark.svg"
                alt="Logo image"
            />
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationContentFooter>
        <!-- App version -->
        <div class="flex flex-col h-20 items-center justify-center px-2">
            <div class="text-xs text-current opacity-50 text-center">v{{ utils.VERSION }}</div>
            <div class="text-xs text-current opacity-50 text-center">PM DEMO &copy; {{ currentYear }}</div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
    >
        <div class="flex items-center space-x-2 pr-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <!--            <button-->
            <!--                class="hidden md:inline-flex"-->
            <!--                mat-icon-button-->
            <!--                (click)="toggleNavigationAppearance()">-->
            <!--                <mat-icon-->
            <!--                    [svgIcon]="'heroicons_outline:arrows-right-left'"></mat-icon>-->
            <!--            </button>-->
        </div>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
<!--            <languages></languages>-->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!--            <search [appearance]="'bar'"></search>-->
            <shortcuts></shortcuts>
            <!--            <messages></messages>-->
            <!--            <notifications></notifications>-->
            <!--            <button-->
            <!--                class="lg:hidden"-->
            <!--                mat-icon-button-->
            <!--                (click)="quickChat.toggle()"-->
            <!--            >-->
            <!--                <mat-icon-->
            <!--                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"-->
            <!--                ></mat-icon>-->
            <!--            </button>-->
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--    <div-->
    <!--        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"-->
    <!--    >-->
    <!--        <span class="text-secondary font-medium"-->
    <!--            >Fuse &copy; {{ currentYear }}</span-->
    <!--        >-->
    <!--    </div>-->
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
